import {styled} from '@mui/material/styles';
import {Theme} from "@mui/system";
import {TabPanel} from "@mui/lab";
import {Tabs} from "@mui/material";

export const SummaryTabPanel = styled(TabPanel)(() => ({
  paddingLeft: 0,
  paddingRight: 0,
}));

export const BorderBottomGrey200Tabs = styled(Tabs)(({theme}: { theme: Theme }) => ({
  borderBottom: `${theme.palette.grey[200]} solid 0.07rem`,
  '& .MuiButtonBase-root.MuiTab-root ': {
    fontSize: '1em'
  }
}));
